import axios from 'axios';
import {
  call, take, race,
} from 'redux-saga/effects';
import urlHelper from './url.helper';
import { urlHelperGioCore, urlHelperGioApi } from './url.helper';

export default function request(params) {
  const {
    headers, body, method, url, responseType,
  } = params;
  let apiURL = urlHelper(url);
  if (url.startsWith('http')) {
    apiURL = url;
  }
  return new Promise((resolve, reject) => axios({
    method,
    url: apiURL,
    data: body,
    headers,
    responseType,
    validateStatus(status) {
      return status <= 500;
    },
  })
    .then(response => ((response.status !== 200 && response.status !== 201) ? reject(response) : response))
    .then(response => resolve(response.data))
    .catch(error => reject(error)));
}

export function authRequest(params) {
  let headers = {};
  const token = localStorage.getItem('token');
  if (token) {
    headers = {
      Authorization: `Bearer ${token}`,
    };
  }
  return request({ ...params, headers });
}
export function requestv2(params) {
  const {
    headers, body, method, url, responseType,
  } = params;
  let apiURL = urlHelper(url);
  if (url.startsWith('http')) {
    apiURL = url;
  }
  return new Promise((resolve, reject) => axios({
    method,
    url: apiURL,
    data: body,
    headers,
    responseType,
    validateStatus(status) {
      return status <= 500;
    },
  })
    .then(response => ((response.status !== 200 && response.status !== 201) ? reject(response) : response))
    .then(response => resolve(response))
    .catch(error => reject(error)));
}

export function authRequestv2(params) {
  let headers = {};
  const token = localStorage.getItem('token');
  if (token) {
    headers = {
      Authorization: `Bearer ${token}`,
    };
  }
  return requestv2({ ...params, headers });
}

export function requestGioCore(params) {
  const {
    headers, body, method, url, responseType,
  } = params;
  let apiURL = urlHelperGioCore(url);
  if (url.startsWith('http')) {
    apiURL = url;
  }
  return new Promise((resolve, reject) => axios({
    method,
    url: apiURL,
    data: body,
    headers,
    responseType,
    validateStatus(status) {
      return status <= 500;
    },
  })
    .then(response => ((response.status !== 200 && response.status !== 201) ? reject(response) : response))
    .then(response => resolve(response.data))
    .catch(error => reject(error)));
}

export function authRequestGioCore(params) {
  let headers = {};
  const token = localStorage.getItem('token');
  if (token) {
    headers = {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
        'Content-Type': 'application/json',
    };
  }
  return requestGioCore({ ...params, headers });
}

export function requestGioApi(params) {
  const {
    headers, body, method, url, responseType,
  } = params;
  let apiURL = urlHelperGioApi(url);
  if (url.startsWith('http')) {
    apiURL = url;
  }
  return new Promise((resolve, reject) => axios({
    method,
    url: apiURL,
    data: body,
    headers,
    responseType,
    validateStatus(status) {
      return status <= 500;
    },
  })
    .then(response => ((response.status !== 200 && response.status !== 201) ? reject(response) : response))
    .then(response => resolve(response.data))
    .catch(error => reject(error)));
}

export function authRequestGioApi(params) {
  let headers = {};
  const token = localStorage.getItem('token');
  if (token) {
    headers = {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
        'Content-Type': 'application/json',
    };
  }
  return requestGioApi({ ...params, headers });
}


export function externalRequest({
  headers, body, method, url,
}) {
  try {
    const apiURL = url;
    const fetchOptions = {
      crossDomain: true,
      method,
      mode: 'cors',
      body,
      headers,
    };
    return new Promise((resolve, reject) => fetch(apiURL, fetchOptions)
      .then(response => (response.status !== 200 ? reject(response) : response))
      .then(response => response.json())
      .then(response => resolve(response))
      .catch((error) => { reject(error); console.error(error);}));
    } catch (error) {
      throw new Error(error);
    }
}
export function externalTimeoutRequest({
  headers, body, method, url, timeout = 240000
}) {
  const apiURL = url;
  const Timeout = (timeout) => {
    let controller = new AbortController();
    setTimeout(() => controller.abort(), timeout);
    return controller;
  };
  const fetchOptions = {
    crossDomain: true,
    method,
    mode: 'cors',
    body,
    headers,
    signal: Timeout(timeout).signal,
  };

  return fetch(apiURL, fetchOptions)
    .then(response => (response.status !== 200 ? console.error(response) : response.json()))
    .catch((error) => { console.error(error); throw new Error(error);});      
  
}
export function externalRequestV2({
  headers, body, method, url,
}) {
  const apiURL = url;
  const fetchOptions = {
    crossDomain: true,
    method,
    mode: 'cors',
    body,
    headers,
  };
  console.log(fetchOptions);
  return fetch(apiURL, fetchOptions)
    .then(response => (response.status !== 200 ? console.error(response) : response.json()))
    .catch((error) => { console.error(error); throw new Error(error);});      

};
export function externalAuthRequest(params) {
  let { headers: headers = {} } = params;
  headers = new Headers(headers);
  const token = localStorage.getItem('token');
  if (token) {
    headers.append('Authorization', `Bearer ${token}`);
  }
  return externalRequest({ ...params, headers });
}

export const cancelable = (saga, cancelAction) => function* (...args) {
  yield race([call(saga, ...args), take(cancelAction)]);
};
